/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../models/account';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "UpdateAccountRequest": {
                    "fields": {
                      "accountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateAccountResponse": {
                    "fields": {
                      "account": {
                        "type": ".squareup.sfs.models.Account",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.UpdateAccountRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.UpdateAccountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateAccountRequest @ squareup/sfs/external/services/account/update_account.proto at 9:1
 */
export const UpdateAccountRequest = $root.lookupType('squareup.sfs.external.service.UpdateAccountRequest');
fixType(UpdateAccountRequest, {
  accountId: {
    required: true
  },
  name: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateAccountRequest);
/**
 * SOURCE UpdateAccountResponse @ squareup/sfs/external/services/account/update_account.proto at 23:1
 */
export const UpdateAccountResponse = $root.lookupType('squareup.sfs.external.service.UpdateAccountResponse');
fixType(UpdateAccountResponse, {
  account: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateAccountResponse);